module.exports = __webpack_public_path__ + "static/media/thais-guimaraes.42167c84.png";